import { useEffect } from 'react';

type DataState = {
  hasData: boolean;
  isLoading: boolean;
};

type PropsType<TState extends { isLoading: boolean; hasData: boolean }> = {
  dataState: TState;
  onFetchData?: () => void;
  isDisabled?: boolean;
};

export const useInitialDataFetch = <
  TState extends { isLoading: boolean; hasData: boolean },
>(
  props: PropsType<TState>,
): DataState => {
  const {
    dataState: { hasData, isLoading },
    isDisabled,
    onFetchData,
  } = props;

  useEffect(() => {
    if (!hasData && !isLoading && !isDisabled) {
      if (!!onFetchData) {
        onFetchData();
      }
    }
  }, [hasData, isLoading, isDisabled, onFetchData]);

  return {
    hasData,
    isLoading,
  };
};
